"use strict";
/**
 * KEO Data Helper Functions
 *
 * These functions fetch and transform KEO (Waste Record Card) data from BDO API.
 *
 * NOTE: This file contains helper functions that require API implementations.
 * The consuming application must provide:
 * - getKeoData() - Fetch KEO data from BDO API
 * - getKeoGeneratedData() - Fetch generated waste data
 * - getKeoTreatedData() - Fetch treated waste data
 * - getKeoForwardedData() - Fetch forwarded waste data
 * - TimeDelayInMs - Delay constant for API pagination
 *
 * These functions are exported for use by other sheet generators in this library.
 * The actual API calls should be injected or implemented by the consuming application.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeoDataAndMappingToList = getKeoDataAndMappingToList;
exports.getKeoDMonthlyStatementataAndMappingToList = getKeoDMonthlyStatementataAndMappingToList;
exports.getKeoDataAndMappingOnlyGeneratedToList = getKeoDataAndMappingOnlyGeneratedToList;
exports.getKeoDataAndMappingOnlyTreatedToList = getKeoDataAndMappingOnlyTreatedToList;
exports.getKeoDataAndMappingOnlyForwardedToList = getKeoDataAndMappingOnlyForwardedToList;
exports.fetchKeoGeneratedDetails = fetchKeoGeneratedDetails;
exports.fetchKeoTreatedDetails = fetchKeoTreatedDetails;
exports.fetchKeoForwardedDetails = fetchKeoForwardedDetails;
exports.getKeoPrintDataAndMaping = getKeoPrintDataAndMaping;
var common_1 = require("../common");
var api_stubs_1 = require("../../api-stubs");
/**
 * Funkcja pobiera dane KEO z API BdoEndpoints_SearchKeo POST ("https://rejestr-bdo.mos.gov.pl/api/WasteRegister/WasteRecordCard/v1/Keo/search")
 * na podstawie przekazanych parametrów:
 * @param {string} ClientId - identyfikator klienta
 * @param {string} ClientSecret - sekret klienta
 * @param {string} EupId - identyfikator EUP
 * @param {number} Year - rok
 * @return {Promise<any>} - zwraca listę kart KEO
 */
function getKeoDataAndMappingToList(ClientId, ClientSecret, EupId, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardList, data, mappedItems, _i, keoCardList_1, keoCard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("🔄 getKeoDataAndMappingToList - rozpoczynam...");
                    console.log("📋 Otrzymane parametry:");
                    console.log("  - ClientId:", ClientId);
                    console.log("  - ClientSecret:", ClientSecret ? "".concat(ClientSecret.substring(0, 10), "...") : "BRAK");
                    console.log("  - EupId:", EupId);
                    console.log("  - Year:", Year);
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardList = [];
                    _a.label = 1;
                case 1:
                    console.log("\uD83D\uDCC4 Pobieranie strony ".concat(pageNumber, " (rozmiar: ").concat(pageSize, ")..."));
                    return [4 /*yield*/, getKeoData(ClientId, ClientSecret, EupId, pageNumber, pageSize, Year)];
                case 2:
                    data = _a.sent();
                    console.log("\u2705 Odpowied\u017A ze strony ".concat(pageNumber, ":"), JSON.stringify(data, null, 2));
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingToList - No Data", properties: { ClientId, EupId, Year } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingToList - Error", properties: { ClientId, EupId, Year, errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        year: item.year,
                        keoId: item.keoId,
                        wasteCode: (0, common_1.extractWasteCode)(item.wasteCode) || "",
                        wasteCodeDescription: (0, common_1.extractWasteDescription)(item.wasteCode) || "",
                        cardNumber: item.cardNumber,
                        createdByUser: item.createdByUser,
                        canBeDeleted: item.canBeDeleted,
                        wasteCodeExtended: item.wasteCodeExtended,
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription,
                        hazardousWasteReclassification: item.hazardousWasteReclassification,
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription,
                    }); });
                    keoCardList.push.apply(keoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    //Sprawdz czy keoCardList nie jest pusta i dla każdego wybranego keoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (keoCardList.length === 0) {
                        return [2 /*return*/, keoCardList];
                    }
                    _i = 0, keoCardList_1 = keoCardList;
                    _a.label = 5;
                case 5:
                    if (!(_i < keoCardList_1.length)) return [3 /*break*/, 11];
                    keoCard = keoCardList_1[_i];
                    return [4 /*yield*/, fetchKeoGeneratedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, fetchKeoTreatedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, fetchKeoForwardedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 8:
                    _a.sent();
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 9:
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    _a.sent(); // 500 ms = 0.5 sekundy
                    _a.label = 10;
                case 10:
                    _i++;
                    return [3 /*break*/, 5];
                case 11: return [2 /*return*/, keoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera dane KEO z API BdoEndpoints_SearchKeo POST ("https://rejestr-bdo.mos.gov.pl/api/WasteRegister/WasteRecordCard/v1/Keo/search")
 * na podstawie przekazanych parametrów:
 * @param {string} ClientId - identyfikator klienta
 * @param {string} ClientSecret - sekret klienta
 * @param {string} EupId - identyfikator EUP
 * @param {number} Year - rok
 * @return {Promise<any>} - zwraca listę kart KEO
 */
function getKeoDMonthlyStatementataAndMappingToList(ClientId, ClientSecret, EupId, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardList, data, mappedItems, _i, keoCardList_2, keoCard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardList = [];
                    _a.label = 1;
                case 1:
                    console.log("\uD83D\uDCC4 Pobieranie strony ".concat(pageNumber, " (rozmiar: ").concat(pageSize, ")..."));
                    return [4 /*yield*/, getKeoData(ClientId, ClientSecret, EupId, pageNumber, pageSize, Year)];
                case 2:
                    data = _a.sent();
                    console.log("\u2705 Odpowied\u017A ze strony ".concat(pageNumber, ":"), JSON.stringify(data, null, 2));
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingToList - No Data", properties: { ClientId, EupId, Year } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingToList - Error", properties: { ClientId, EupId, Year, errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        year: item.year,
                        keoId: item.keoId,
                        cardNumber: item.cardNumber,
                        wasteCode: (0, common_1.extractWasteCode)(item.wasteCode) || "",
                        wasteCodeDescription: (0, common_1.extractWasteDescription)(item.wasteCode) || "",
                        isDangerous: (0, common_1.isDangerousWaste)(item.wasteCode),
                        createdByUser: item.createdByUser,
                        canBeDeleted: item.canBeDeleted,
                        wasteCodeExtended: item.wasteCodeExtended,
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription,
                        hazardousWasteReclassification: item.hazardousWasteReclassification,
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription,
                    }); });
                    keoCardList.push.apply(keoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    //Sprawdz czy keoCardList nie jest pusta i dla każdego wybranego keoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (keoCardList.length === 0) {
                        return [2 /*return*/, keoCardList];
                    }
                    _i = 0, keoCardList_2 = keoCardList;
                    _a.label = 5;
                case 5:
                    if (!(_i < keoCardList_2.length)) return [3 /*break*/, 9];
                    keoCard = keoCardList_2[_i];
                    return [4 /*yield*/, fetchKeoGeneratedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 6:
                    _a.sent();
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 7:
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    _a.sent(); // 500 ms = 0.5 sekundy
                    _a.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 5];
                case 9: return [2 /*return*/, keoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera dane KEO z API BdoEndpoints_SearchKeo POST ("https://rejestr-bdo.mos.gov.pl/api/WasteRegister/WasteRecordCard/v1/Keo/search")
 * na podstawie przekazanych parametrów, ale tylko wytworzone.
 * @param {string} ClientId - identyfikator klienta
 * @param {string} ClientSecret - sekret klienta
 * @param {string} EupId - identyfikator EUP
 * @param {number} Year - rok
 * @return {Promise<any>} - zwraca listę kart KEO
 */
function getKeoDataAndMappingOnlyGeneratedToList(ClientId, ClientSecret, EupId, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardList, data, mappedItems, _i, keoCardList_3, keoCard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKeoData(ClientId, ClientSecret, EupId, pageNumber, pageSize, Year)];
                case 2:
                    data = _a.sent();
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyGeneratedToList - No Data", properties: { ClientId, EupId, Year } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyGeneratedToList - Error", properties: { ClientId, EupId, Year, errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        year: item.year,
                        keoId: item.keoId,
                        cardNumber: item.cardNumber,
                        wasteCode: (0, common_1.extractWasteCode)(item.wasteCode) || "",
                        wasteCodeDescription: (0, common_1.extractWasteDescription)(item.wasteCode) || "",
                        createdByUser: item.createdByUser,
                        canBeDeleted: item.canBeDeleted,
                        wasteCodeExtended: item.wasteCodeExtended,
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription,
                        hazardousWasteReclassification: item.hazardousWasteReclassification,
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription,
                    }); });
                    keoCardList.push.apply(keoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    //Sprawdz czy keoCardList nie jest pusta i dla każdego wybranego keoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (keoCardList.length === 0) {
                        return [2 /*return*/, keoCardList];
                    }
                    _i = 0, keoCardList_3 = keoCardList;
                    _a.label = 5;
                case 5:
                    if (!(_i < keoCardList_3.length)) return [3 /*break*/, 9];
                    keoCard = keoCardList_3[_i];
                    return [4 /*yield*/, fetchKeoGeneratedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 6:
                    _a.sent();
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 7:
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    _a.sent(); // 500 ms = 0.5 sekundy
                    _a.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 5];
                case 9: return [2 /*return*/, keoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera dane KEO z API BdoEndpoints_SearchKeo POST ("https://rejestr-bdo.mos.gov.pl/api/WasteRegister/WasteRecordCard/v1/Keo/search")
 * na podstawie przekazanych parametrów, ale tylko przetworzone we własnym zakresie.
 * @param {string} ClientId - identyfikator klienta
 * @param {string} ClientSecret - sekret klienta
 * @param {string} EupId - identyfikator EUP
 * @param {number} Year - rok
 * @return {Promise<any>} - zwraca listę kart KEO
 */
function getKeoDataAndMappingOnlyTreatedToList(ClientId, ClientSecret, EupId, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardList, data, mappedItems, _i, keoCardList_4, keoCard;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKeoData(ClientId, ClientSecret, EupId, pageNumber, pageSize, Year)];
                case 2:
                    data = _a.sent();
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyTreatedToList - No Data", properties: { ClientId, EupId, Year } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyTreatedToList - Error", properties: { ClientId, EupId, Year, errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        year: item.year,
                        keoId: item.keoId,
                        cardNumber: item.cardNumber,
                        wasteCode: (0, common_1.extractWasteCode)(item.wasteCode) || "",
                        wasteCodeDescription: (0, common_1.extractWasteDescription)(item.wasteCode) || "",
                        createdByUser: item.createdByUser,
                        canBeDeleted: item.canBeDeleted,
                        wasteCodeExtended: item.wasteCodeExtended,
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription,
                        hazardousWasteReclassification: item.hazardousWasteReclassification,
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription,
                    }); });
                    keoCardList.push.apply(keoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    //Sprawdz czy keoCardList nie jest pusta i dla każdego wybranego keoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (keoCardList.length === 0) {
                        return [2 /*return*/, keoCardList];
                    }
                    _i = 0, keoCardList_4 = keoCardList;
                    _a.label = 5;
                case 5:
                    if (!(_i < keoCardList_4.length)) return [3 /*break*/, 9];
                    keoCard = keoCardList_4[_i];
                    return [4 /*yield*/, fetchKeoTreatedDetails(ClientId, ClientSecret, EupId, keoCard)];
                case 6:
                    _a.sent();
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 7:
                    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    _a.sent(); // 500 ms = 0.5 sekundy
                    _a.label = 8;
                case 8:
                    _i++;
                    return [3 /*break*/, 5];
                case 9: return [2 /*return*/, keoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera dane KEO z API BdoEndpoints_SearchKeo POST ("https://rejestr-bdo.mos.gov.pl/api/WasteRegister/WasteRecordCard/v1/Keo/search")
 * na podstawie przekazanych parametrów, ale tylko przekazane dalej.
 * @param {string} ClientId - identyfikator klienta
 * @param {string} ClientSecret - sekret klienta
 * @param {string} EupId - identyfikator EUP
 * @param {number} Year - rok
 * @return {Promise<any>} - zwraca listę kart KEO z danymi przekazanymi dalej
 */
function getKeoDataAndMappingOnlyForwardedToList(ClientId, ClientSecret, EupId, Year) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardList, data, mappedItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKeoData(ClientId, ClientSecret, EupId, pageNumber, pageSize, Year)];
                case 2:
                    data = _a.sent();
                    // Sprawdź, czy dane zostały poprawnie pobrane
                    if (!data || !data.items || data.items.length === 0) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyForwardedToList - No Data", properties: { ClientId, EupId, Year } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        // TODO: Add telemetry - appInsights.trackEvent({ name: "getKeoDataAndMappingOnlyForwardedToList - Error", properties: { ClientId, EupId, Year, errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) { return ({
                        year: item.year,
                        keoId: item.keoId,
                        cardNumber: item.cardNumber,
                        wasteCode: (0, common_1.extractWasteCode)(item.wasteCode) || "",
                        wasteCodeDescription: (0, common_1.extractWasteDescription)(item.wasteCode) || "",
                        createdByUser: item.createdByUser,
                        canBeDeleted: item.canBeDeleted,
                        wasteCodeExtended: item.wasteCodeExtended,
                        wasteCodeExtendedDescription: item.wasteCodeExtendedDescription,
                        hazardousWasteReclassification: item.hazardousWasteReclassification,
                        hazardousWasteReclassificationDescription: item.hazardousWasteReclassificationDescription,
                    }); });
                    keoCardList.push.apply(keoCardList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    //Sprawdz czy keoCardList nie jest pusta i dla każdego wybranego keoId z listy KpoCardList pobierz dane szczegółowe funkcją getKpoPrintingPage
                    if (keoCardList.length === 0) {
                        return [2 /*return*/, keoCardList];
                    }
                    //for (const keoCard of keoCardList) {
                    //    await fetchKeoForwardedDetails(ClientId, ClientSecret, EupId, keoCard);
                    //    // Oczekiwanie 0.5 sekundy przed ponownym pobraniem danych
                    //    await new Promise(resolve => setTimeout(resolve, TimeDelayInMs)); // 500 ms = 0.5 sekundy
                    //}
                    console.log("📄 Liczba kart KEO z danymi przekazanymi dalej:", keoCardList.length);
                    console.log("📄 Dane KEO:", JSON.stringify(keoCardList, null, 4));
                    console.log("✅ getKeoDataAndMappingOnlyForwardedToList - zakończono.");
                    return [2 /*return*/, keoCardList];
            }
        });
    });
}
/**
 * Funkcja pobiera szczegółowe dane KEO (Generated) dla podanego keoCard.
 */
function fetchKeoGeneratedDetails(ClientId, ClientSecret, EupId, keoCard) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, totalResultNumber, itemsFetched, data, firstThreeIds, itemsNeeded, itemsToTake, itemsToAdd, lastAddedId;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Jeśli dane Generated już zostały pobrane, pomiń przetwarzanie (zabezpieczenie przed podwójnym wywołaniem)
                    if (keoCard.Generated !== undefined && keoCard.Generated !== null) {
                        console.log("⚠️ fetchKeoGeneratedDetails - dane już istnieją, pomijam przetwarzanie");
                        return [2 /*return*/, keoCard];
                    }
                    pageSize = 50;
                    pageNumber = 1;
                    totalPagesNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    totalResultNumber = 0;
                    itemsFetched = 0;
                    _c.label = 1;
                case 1:
                    console.log("\uD83D\uDCC4 fetchKeoGeneratedDetails - pobieranie strony ".concat(pageNumber, ", pageSize: ").concat(pageSize, ", itemsFetched: ").concat(itemsFetched));
                    console.log("\uD83D\uDD0D WYWO\u0141ANIE API: ClientId=".concat(ClientId, ", EupId=").concat(EupId, ", keoId=").concat(keoCard.keoId, ", pageNumber=").concat(pageNumber, ", pageSize=").concat(pageSize));
                    return [4 /*yield*/, getKeoGeneratedData(ClientId, ClientSecret, EupId, keoCard.keoId, pageNumber, pageSize)];
                case 2:
                    data = _c.sent();
                    // Sprawdz czy data zawiera wartość
                    if (!data || !data.keoDto || data.keoDto.length === 0) {
                        // Brak danych - przerwij pętlę
                        return [3 /*break*/, 5];
                    }
                    // Aktualizuj zmienne paginacji
                    totalPagesNumber = data.generatedKeos.TotalPagesNumber;
                    hasPreviousPage = data.generatedKeos.HasPreviousPage;
                    hasNextPage = data.generatedKeos.HasNextPage;
                    totalResultNumber = data.generatedKeos.totalResultNumber || data.generatedKeos.TotalResultNumber || 0;
                    console.log("\uD83D\uDCCA Paginacja - strona: ".concat(pageNumber, ", hasNextPage: ").concat(hasNextPage, ", totalPages: ").concat(totalPagesNumber, ", totalResults: ").concat(totalResultNumber, ", pobrano z API: ").concat(data.generatedKeos.items.length));
                    firstThreeIds = data.generatedKeos.items.slice(0, 3).map(function (item) { return item.keoGeneratedId; });
                    console.log("\uD83C\uDD94 Pierwsze 3 keoGeneratedId z API dla strony ".concat(pageNumber, ":"), firstThreeIds);
                    // Inicjalizacja obiektu Generated przy pierwszej iteracji
                    if (keoCard.Generated === undefined) {
                        keoCard.Generated = {};
                        keoCard.Generated.wasteMassServicesSum = data.wasteMassServicesSum;
                        keoCard.Generated.wasteMassSum = data.wasteMassSum;
                        // Mapowanie szczegółowych danych do Generated
                        keoCard.Generated.wasteMass = data.keoDto.wasteMass;
                        keoCard.Generated.wasteCodeId = data.keoDto.wasteCodeId;
                        keoCard.Generated.createdByUserId = data.keoDto.createdByUserId;
                        keoCard.Generated.isWasteGenerating = data.keoDto.isWasteGenerating;
                        keoCard.Generated.isWasteCollecting = data.keoDto.isWasteCollecting;
                        keoCard.Generated.isSalvage = data.keoDto.isSalvage;
                        keoCard.Generated.isNeutralization = data.keoDto.isNeutralization;
                        keoCard.Generated.items = []; // Inicjalizacja tablicy items
                    }
                    itemsNeeded = totalResultNumber > 0 ? totalResultNumber - itemsFetched : data.generatedKeos.items.length;
                    itemsToTake = Math.min(data.generatedKeos.items.length, itemsNeeded);
                    console.log("\uD83C\uDFAF Potrzebujemy ".concat(itemsNeeded, " items, API zwr\u00F3ci\u0142o ").concat(data.generatedKeos.items.length, ", bierzemy ").concat(itemsToTake));
                    itemsToAdd = data.generatedKeos.items.slice(0, itemsToTake).map(function (item) { return ({
                        wasteMassInstallation: item.wasteMassInstallation,
                        wasteMassExcludingInstallation: item.wasteMassExcludingInstallation,
                        keoGeneratedId: item.keoGeneratedId,
                        installationName: item.installationName,
                        wasteFromServices: item.wasteFromServices,
                        createdByUser: item.createdByUser,
                        manufactureDate: item.manufactureDate ? new Date(item.manufactureDate) : undefined
                    }); });
                    (_a = keoCard.Generated.items).push.apply(_a, itemsToAdd);
                    itemsFetched += itemsToAdd.length;
                    // Log ID ostatniego dodanego itemu dla weryfikacji
                    if (itemsToAdd.length > 0) {
                        lastAddedId = itemsToAdd[itemsToAdd.length - 1].keoGeneratedId;
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Generated.items.length, ", itemsFetched: ").concat(itemsFetched, ", ostatni dodany ID: ").concat(lastAddedId));
                    }
                    else {
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Generated.items.length, ", itemsFetched: ").concat(itemsFetched));
                    }
                    // Sprawdź czy zebraliśmy już wszystkie wymagane items
                    if (totalResultNumber > 0 && itemsFetched >= totalResultNumber) {
                        console.log("\uD83C\uDFAF Zebrano wszystkie items (".concat(itemsFetched, "/").concat(totalResultNumber, "), przerywam p\u0119tl\u0119"));
                        return [3 /*break*/, 5];
                    }
                    pageNumber++;
                    // Oczekiwanie przed następnym żądaniem
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 3:
                    // Oczekiwanie przed następnym żądaniem
                    _c.sent(); // 500 ms = 0.5 sekundy
                    _c.label = 4;
                case 4:
                    if (totalResultNumber > 0 && itemsFetched < totalResultNumber && pageNumber <= 100) return [3 /*break*/, 1];
                    _c.label = 5;
                case 5:
                    console.log("\uD83C\uDFC1 P\u0119tla zako\u0144czona - pageNumber: ".concat(pageNumber, ", itemsFetched: ").concat(itemsFetched, ", totalResultNumber: ").concat(totalResultNumber));
                    // Po zakończeniu pętli sprawdź czy są dane
                    if (!keoCard.Generated || !Array.isArray(keoCard.Generated.items) || keoCard.Generated.items.length === 0) {
                        keoCard.Generated = null; // Ustaw Generated na null, jeśli nie ma danych
                    }
                    // Zwróć keoCard z wypełnionymi danymi Generated
                    console.log("📄 Liczba kart KEO Generated items:", ((_b = keoCard.Generated) === null || _b === void 0 ? void 0 : _b.items.length) || 0);
                    console.log("✅ fetchKeoGeneratedDetails - zakończono.");
                    return [2 /*return*/, keoCard];
            }
        });
    });
}
/**
 * Funkcja pobiera szczegółowe dane KEO (Treated) dla podanego keoCard.
 */
function fetchKeoTreatedDetails(ClientId, ClientSecret, EupId, keoCard) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, totalResultNumber, itemsFetched, data, firstThreeIds, itemsNeeded, itemsToTake, itemsToAdd, lastAddedId;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Jeśli dane Treated już zostały pobrane, pomiń przetwarzanie (zabezpieczenie przed podwójnym wywołaniem)
                    if (keoCard.Treated !== undefined && keoCard.Treated !== null) {
                        console.log("⚠️ fetchKeoTreatedDetails - dane już istnieją, pomijam przetwarzanie");
                        return [2 /*return*/, keoCard];
                    }
                    pageSize = 50;
                    pageNumber = 1;
                    totalPagesNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    totalResultNumber = 0;
                    itemsFetched = 0;
                    _c.label = 1;
                case 1:
                    console.log("\uD83D\uDCC4 fetchKeoTreatedDetails - pobieranie strony ".concat(pageNumber, ", pageSize: ").concat(pageSize, ", itemsFetched: ").concat(itemsFetched));
                    console.log("\uD83D\uDD0D WYWO\u0141ANIE API: ClientId=".concat(ClientId, ", EupId=").concat(EupId, ", keoId=").concat(keoCard.keoId, ", pageNumber=").concat(pageNumber, ", pageSize=").concat(pageSize));
                    return [4 /*yield*/, getKeoTreatedData(ClientId, ClientSecret, EupId, keoCard.keoId, pageNumber, pageSize)];
                case 2:
                    data = _c.sent();
                    // Sprawdz czy data zawiera wartość
                    if (!data || !data.keoDto || data.keoDto.length === 0) {
                        // Brak danych - przerwij pętlę
                        return [3 /*break*/, 5];
                    }
                    // Aktualizuj zmienne paginacji
                    totalPagesNumber = data.treatedKeos.TotalPagesNumber;
                    hasPreviousPage = data.treatedKeos.HasPreviousPage;
                    hasNextPage = data.treatedKeos.HasNextPage;
                    totalResultNumber = data.treatedKeos.totalResultNumber || data.treatedKeos.TotalResultNumber || 0;
                    console.log("\uD83D\uDCCA Paginacja - strona: ".concat(pageNumber, ", hasNextPage: ").concat(hasNextPage, ", totalPages: ").concat(totalPagesNumber, ", totalResults: ").concat(totalResultNumber, ", pobrano z API: ").concat(data.treatedKeos.items.length));
                    firstThreeIds = data.treatedKeos.items.slice(0, 3).map(function (item) { return item.keoTreatedId; });
                    console.log("\uD83C\uDD94 Pierwsze 3 keoTreatedId z API dla strony ".concat(pageNumber, ":"), firstThreeIds);
                    // Inicjalizacja obiektu Treated przy pierwszej iteracji
                    if (keoCard.Treated === undefined) {
                        keoCard.Treated = {};
                        keoCard.Treated.recycleSum = data.recycleSum;
                        keoCard.Treated.preparationForReUseSum = data.preparationForReUseSum;
                        keoCard.Treated.fillingUpDisadvantagedAreasSum = data.fillingUpDisadvantagedAreasSum;
                        keoCard.Treated.anotherRecoveryProcessSum = data.anotherRecoveryProcessSum;
                        keoCard.Treated.neutralizationSum = data.neutralizationSum;
                        // Mapowanie szczegółowych danych do Treated
                        keoCard.Treated.createdByUserId = data.keoDto.createdByUserId;
                        keoCard.Treated.isWasteGenerating = data.keoDto.isWasteGenerating;
                        keoCard.Treated.isWasteCollecting = data.keoDto.isWasteCollecting;
                        keoCard.Treated.isSalvage = data.keoDto.isSalvage;
                        keoCard.Treated.isNeutralization = data.keoDto.isNeutralization;
                        keoCard.Treated.wasteMass = data.keoDto.wasteMass;
                        keoCard.Treated.canBeDeleted = data.keoDto.canBeDeleted;
                        keoCard.Treated.items = []; // Inicjalizacja tablicy items
                    }
                    itemsNeeded = totalResultNumber > 0 ? totalResultNumber - itemsFetched : data.treatedKeos.items.length;
                    itemsToTake = Math.min(data.treatedKeos.items.length, itemsNeeded);
                    console.log("\uD83C\uDFAF Potrzebujemy ".concat(itemsNeeded, " items, API zwr\u00F3ci\u0142o ").concat(data.treatedKeos.items.length, ", bierzemy ").concat(itemsToTake));
                    itemsToAdd = data.treatedKeos.items.slice(0, itemsToTake).map(function (item) { return ({
                        treatedWasteMass: item.treatedWasteMass,
                        pcbContent: item.pcbContent,
                        massInTonnes: item.massInTonnes,
                        keoTreatedId: item.keoTreatedId,
                        wasteProcess: item.wasteProcess,
                        wasteProcessName: item.wasteProcessName,
                        isRecycle: item.isRecycle,
                        isFillingUpDisadvantagedAreas: item.isFillingUpDisadvantagedAreas,
                        isPreparationForReUse: item.isPreparationForReUse,
                        isAnotherRecoveryProcess: item.isAnotherRecoveryProcess,
                        isNeutralization: item.isNeutralization,
                        createdByUser: item.createdByUser,
                        createdAt: item.createdAt ? new Date(item.createdAt) : undefined,
                        wasteRecycleTime: item.wasteRecycleTime ? new Date(item.wasteRecycleTime) : undefined,
                        installationName: item.installationName,
                        lossOfWasteStatus: item.lossOfWasteStatus,
                        type: item.type
                    }); });
                    (_a = keoCard.Treated.items).push.apply(_a, itemsToAdd);
                    itemsFetched += itemsToAdd.length;
                    // Log ID ostatniego dodanego itemu dla weryfikacji
                    if (itemsToAdd.length > 0) {
                        lastAddedId = itemsToAdd[itemsToAdd.length - 1].keoTreatedId;
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Treated.items.length, ", itemsFetched: ").concat(itemsFetched, ", ostatni dodany ID: ").concat(lastAddedId));
                    }
                    else {
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Treated.items.length, ", itemsFetched: ").concat(itemsFetched));
                    }
                    // Sprawdź czy zebraliśmy już wszystkie wymagane items
                    if (totalResultNumber > 0 && itemsFetched >= totalResultNumber) {
                        console.log("\uD83C\uDFAF Zebrano wszystkie items (".concat(itemsFetched, "/").concat(totalResultNumber, "), przerywam p\u0119tl\u0119"));
                        return [3 /*break*/, 5];
                    }
                    pageNumber++;
                    // Oczekiwanie przed następnym żądaniem
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, api_stubs_1.TimeDelayInMs); })];
                case 3:
                    // Oczekiwanie przed następnym żądaniem
                    _c.sent(); // 500 ms = 0.5 sekundy
                    _c.label = 4;
                case 4:
                    if (totalResultNumber > 0 && itemsFetched < totalResultNumber && pageNumber <= 100) return [3 /*break*/, 1];
                    _c.label = 5;
                case 5:
                    console.log("\uD83C\uDFC1 P\u0119tla zako\u0144czona - pageNumber: ".concat(pageNumber, ", itemsFetched: ").concat(itemsFetched, ", totalResultNumber: ").concat(totalResultNumber));
                    // Po zakończeniu pętli sprawdź czy są dane
                    if (!keoCard.Treated || !Array.isArray(keoCard.Treated.items) || keoCard.Treated.items.length === 0) {
                        keoCard.Treated = null; // Ustaw Treated na null, jeśli nie ma danych
                    }
                    // Zwróć keoCard z wypełnionymi danymi Treated
                    console.log("📄 Liczba kart KEO Treated items:", ((_b = keoCard.Treated) === null || _b === void 0 ? void 0 : _b.items.length) || 0);
                    console.log("✅ fetchKeoTreatedDetails - zakończono.");
                    return [2 /*return*/, keoCard];
            }
        });
    });
}
/**
 * Funkcja pobiera szczegółowe dane KEO (Forwarded) dla podanego keoCard.
 */
function fetchKeoForwardedDetails(ClientId, ClientSecret, EupId, keoCard) {
    return __awaiter(this, void 0, void 0, function () {
        var pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, totalResultNumber, itemsFetched, data, firstThreeIds, itemsNeeded, itemsToTake, itemsToAdd, lastAddedId;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Jeśli dane Forwarded już zostały pobrane, pomiń przetwarzanie (zabezpieczenie przed podwójnym wywołaniem)
                    if (keoCard.Forwarded !== undefined && keoCard.Forwarded !== null) {
                        console.log("⚠️ fetchKeoForwardedDetails - dane już istnieją, pomijam przetwarzanie");
                        return [2 /*return*/, keoCard];
                    }
                    pageSize = 50;
                    pageNumber = 1;
                    totalPagesNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    totalResultNumber = 0;
                    itemsFetched = 0;
                    _c.label = 1;
                case 1:
                    console.log("\uD83D\uDCC4 fetchKeoForwardedDetails - pobieranie strony ".concat(pageNumber, ", pageSize: ").concat(pageSize, ", itemsFetched: ").concat(itemsFetched));
                    console.log("\uD83D\uDD0D WYWO\u0141ANIE API: ClientId=".concat(ClientId, ", EupId=").concat(EupId, ", keoId=").concat(keoCard.keoId, ", pageNumber=").concat(pageNumber, ", pageSize=").concat(pageSize));
                    return [4 /*yield*/, getKeoForwardedData(ClientId, ClientSecret, EupId, keoCard.keoId, pageNumber, pageSize)];
                case 2:
                    data = _c.sent();
                    // Sprawdz czy data zawiera wartość
                    if (!data || !data.forwardedForwardedKeos || !data.forwardedForwardedKeos.items || data.forwardedForwardedKeos.items.length === 0) {
                        // Brak danych - przerwij pętlę
                        return [3 /*break*/, 4];
                    }
                    // Aktualizuj zmienne paginacji
                    totalPagesNumber = data.forwardedForwardedKeos.totalPagesNumber;
                    hasPreviousPage = data.forwardedForwardedKeos.hasPreviousPage;
                    hasNextPage = data.forwardedForwardedKeos.hasNextPage;
                    totalResultNumber = data.forwardedForwardedKeos.totalResultNumber;
                    console.log("\uD83D\uDCCA Paginacja - strona: ".concat(pageNumber, ", hasNextPage: ").concat(hasNextPage, ", totalPages: ").concat(totalPagesNumber, ", totalResults: ").concat(totalResultNumber, ", pobrano z API: ").concat(data.forwardedForwardedKeos.items.length));
                    firstThreeIds = data.forwardedForwardedKeos.items.slice(0, 3).map(function (item) { return item.keoForwardedId; });
                    console.log("\uD83C\uDD94 Pierwsze 3 keoForwardedId z API dla strony ".concat(pageNumber, ":"), firstThreeIds);
                    // Inicjalizacja obiektu Forwarded przy pierwszej iteracji
                    if (keoCard.Forwarded === undefined) {
                        keoCard.Forwarded = {};
                        // Mapowanie szczegółowych danych do Forwarded
                        keoCard.Forwarded.countryWasteMass = data.countryWasteMass;
                        keoCard.Forwarded.abroadWasteMass = data.abroadWasteMass;
                        // Typy danych dla keoDto (jeśli keoDto istnieje)
                        if (data.keoDto) {
                            keoCard.Forwarded.abroadWasteMass = data.keoDto.abroadWasteMass;
                            keoCard.Forwarded.wasteCodeId = data.keoDto.wasteCodeId;
                            keoCard.Forwarded.createdByUserId = data.keoDto.createdByUserId;
                            keoCard.Forwarded.isWasteGenerating = data.keoDto.isWasteGenerating;
                            keoCard.Forwarded.isWasteCollecting = data.keoDto.isWasteCollecting;
                            keoCard.Forwarded.isSalvage = data.keoDto.isSalvage;
                            keoCard.Forwarded.isNeutralization = data.keoDto.isNeutralization;
                            keoCard.Forwarded.wasteMass = data.keoDto.wasteMass;
                            keoCard.Forwarded.canBeDeleted = data.keoDto.canBeDeleted;
                        }
                        keoCard.Forwarded.items = []; // Inicjalizacja tablicy items
                    }
                    itemsNeeded = totalResultNumber - itemsFetched;
                    itemsToTake = Math.min(data.forwardedForwardedKeos.items.length, itemsNeeded);
                    console.log("\uD83C\uDFAF Potrzebujemy ".concat(itemsNeeded, " items, API zwr\u00F3ci\u0142o ").concat(data.forwardedForwardedKeos.items.length, ", bierzemy ").concat(itemsToTake));
                    itemsToAdd = data.forwardedForwardedKeos.items.slice(0, itemsToTake).map(function (item) { return ({
                        wasteMass: item.wasteMass,
                        emergencyModeCardNumber: item.emergencyModeCardNumber,
                        keoForwardedId: item.keoForwardedId,
                        wasteCollectionDate: item.wasteCollectionDate ? new Date(item.wasteCollectionDate) : undefined,
                        cardNumberKpo: item.cardNumberKpo,
                        cardNumberKpok: item.cardNumberKpok,
                        transferWay: item.transferWay,
                        transportDate: item.transportDate ? new Date(item.transportDate) : undefined,
                        createdByUser: item.createdByUser
                    }); });
                    (_a = keoCard.Forwarded.items).push.apply(_a, itemsToAdd);
                    itemsFetched += itemsToAdd.length;
                    // Log ID ostatniego dodanego itemu dla weryfikacji
                    if (itemsToAdd.length > 0) {
                        lastAddedId = itemsToAdd[itemsToAdd.length - 1].keoForwardedId;
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Forwarded.items.length, ", itemsFetched: ").concat(itemsFetched, ", ostatni dodany ID: ").concat(lastAddedId));
                    }
                    else {
                        console.log("\u2705 Dodano ".concat(itemsToAdd.length, " items, \u0142\u0105cznie w tablicy: ").concat(keoCard.Forwarded.items.length, ", itemsFetched: ").concat(itemsFetched));
                    }
                    // Sprawdź czy zebraliśmy już wszystkie wymagane items
                    if (totalResultNumber > 0 && itemsFetched >= totalResultNumber) {
                        console.log("\uD83C\uDFAF Zebrano wszystkie items (".concat(itemsFetched, "/").concat(totalResultNumber, "), przerywam p\u0119tl\u0119"));
                        return [3 /*break*/, 4];
                    }
                    pageNumber++;
                    _c.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _c.label = 4;
                case 4:
                    console.log("\uD83C\uDFC1 P\u0119tla zako\u0144czona - pageNumber: ".concat(pageNumber, ", hasNextPage: ").concat(hasNextPage, ", totalPagesNumber: ").concat(totalPagesNumber));
                    // Po zakończeniu pętli sprawdź czy są dane
                    if (!keoCard.Forwarded || !Array.isArray(keoCard.Forwarded.items) || keoCard.Forwarded.items.length === 0) {
                        keoCard.Forwarded = null; // Ustaw Forwarded na null, jeśli nie ma danych
                    }
                    // Zwróć keoCard z wypełnionymi danymi Forwarded
                    console.log("📄 Liczba kart KEO z danymi przekazanymi dalej:", ((_b = keoCard.Forwarded) === null || _b === void 0 ? void 0 : _b.items.length) || 0);
                    console.log("📄 Dane KEO:", JSON.stringify(keoCard, null, 4));
                    console.log("✅ fetchKeoForwardedDetails - zakończono.");
                    return [2 /*return*/, keoCard];
            }
        });
    });
}
function getKeoPrintDataAndMaping(eupType, cardNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var year, pageSize, pageNumber, totalPagesNumber, hasPreviousPage, hasNextPage, keoCardShortList, cardStatus, data, mappedItems, keoItem, keoId, keoPrintData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    year = (0, common_1.extractYearFromKeoCardNumber)(cardNumber);
                    if (!year) {
                        throw new Error("Nie uda\u0142o si\u0119 wyodr\u0119bni\u0107 roku z numeru karty KEO: ".concat(cardNumber));
                    }
                    pageSize = 50;
                    pageNumber = 1;
                    hasPreviousPage = false;
                    hasNextPage = false;
                    keoCardShortList = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, getKeoData(eupType.clientId, eupType.clientSecret, eupType.eupId, pageNumber, pageSize, year)];
                case 2:
                    data = _a.sent();
                    if (!data || !data.items || data.items.length === 0) {
                        //appInsights.trackEvent({ name: "getAllKeoInYearDataAndMappingToList - No Data", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString() } });
                        //throw new Error("Brak danych do raportu dla zadanych kryteriów.");
                    }
                    else if (data.error) {
                        //appInsights.trackEvent({ name: "getAllKeoInYearDataAndMappingToList - Error", properties: { clientId: eupType.clientId, eupId: eupType.eupId, Year: Year.toString(), errorMessage: data.error.message } });
                        //throw new Error(`Błąd podczas pobierania danych KEO: ${data.error.message}`);
                    }
                    mappedItems = data.items.map(function (item) {
                        // Zachowaj cardStatus dla karty o odpowiednim numerze
                        if (item.cardNumber === cardNumber && item.cardStatus) {
                            cardStatus = item.cardStatus;
                        }
                        return {
                            keoId: item.keoId,
                            cardNumber: item.cardNumber
                        };
                    });
                    keoCardShortList.push.apply(keoCardShortList, mappedItems);
                    totalPagesNumber = data.totalPagesNumber;
                    hasPreviousPage = data.hasPreviousPage;
                    hasNextPage = data.hasNextPage;
                    pageNumber++;
                    _a.label = 3;
                case 3:
                    if (hasNextPage && pageNumber <= totalPagesNumber) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4:
                    if (keoCardShortList.length === 0) {
                        throw new Error("Brak danych KEO dla roku ".concat(year, " i MPD: ").concat(eupType.identificationNumber));
                    }
                    keoItem = keoCardShortList.find(function (item) { return item.cardNumber === cardNumber; });
                    if (!keoItem) {
                        throw new Error("Nie znaleziono karty KEO o numerze: ".concat(cardNumber, "."));
                    }
                    keoId = keoItem.keoId;
                    if (!keoId) {
                        throw new Error("Brak keoId dla karty KEO o numerze: ".concat(cardNumber, "."));
                    }
                    return [4 /*yield*/, getKeoPrintingPage(eupType.clientId, eupType.clientSecret, cardNumber, eupType.eupId, keoId)];
                case 5:
                    keoPrintData = _a.sent();
                    if (!keoPrintData) {
                        throw new Error("Nie uda\u0142o si\u0119 pobra\u0107 danych do wydruku dla karty KEO o numerze: ".concat(cardNumber));
                    }
                    // 5. Zwróć dane do wydruku wraz z metadata
                    return [2 /*return*/, {
                            printData: keoPrintData,
                            metadata: {
                                keoId: keoId,
                                cardNumber: cardNumber,
                                cardStatus: cardStatus
                            }
                        }];
            }
        });
    });
}
//# sourceMappingURL=keo_card.js.map